import React from 'react';
import PropTypes from 'prop-types';

import Icon from '~/core/scripts/components/Icon';
import Button from '~/scripts/components/Button';

const ClearIndicator = ({ innerProps }) => (
  <Button clear {...innerProps}>
    <Icon type="close" height={14} width={14} />
  </Button>
);

ClearIndicator.displayName = 'ClearIndicator';

ClearIndicator.propTypes = {
  innerProps: PropTypes.object,
};

export default ClearIndicator;
